<template>
  <div>
    <h4 class="fixText primaryText--text mb-2">Bygg oversikt</h4>
    <v-card v-if="houses.length > 0" class="building-card pt-4 mb-6" outlined>
      <span v-for="(house, index) in houses" :key="index">
        <v-btn
          :class="{
            'building-btn-active':
              house.id.toString() === $route.params.houseId,
          }"
          class="building-btn px-1 mx-2 mb-4"
          style="min-width: 54px"
          @click="goToHouse(house)"
        >
          {{ fixHouseName(house.houseNum) }}
        </v-btn>
      </span>
    </v-card>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "ProjectBuildings",
  props: {
    houses: {},
  },

  methods: {
    goToHouse(house) {
      if (this.$route.params.houseId === house.id.toString()) {
        this.$emit("activeHouse", null);
        this.$router.go(-1);
      } else if (this.$route.params.houseId) {
        this.$emit("activeHouse", house);
        this.$router.replace({
          name: "ProjectHouse",
          params: { id: this.$route.params.id, houseId: house.id.toString() },
        });
      } else {
        this.$emit("activeHouse", house);
        this.$router.push({
          name: "ProjectHouse",
          params: { id: this.$route.params.id, houseId: house.id.toString() },
        });
      }
    },
    fixHouseName(name) {
      //Make name to array. Splitt by space
      const myArray = name.split(" ");
      //If only name is one word
      if (myArray.length === 1) {
        //Return first 3 letters in name
        return name.slice(0, 5);
      } else if (myArray.length > 1) {
        //If name is mere than one word
        //Take first letter from every word => make this one string (No space) => return first 3 letters off this string
        var text = myArray
          .map((x) => x.slice(0, 1))
          .join("")
          .slice(0, 5);
        return text;
      } else {
        return name;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.fixText {
  position: relative;
}
</style>

<style lang="scss">
.building-card {
  text-align: center;
  background-color: transparent !important;
  .building-btn {
    font-size: 1.2rem !important;
    font-weight: bold;
  }
  .building-btn-active {
    background-color: var(--v-secondary-base) !important;
    border: 3px solid var(--v-primary-base);
    color: var(--v-primary-base) !important;
  }
}
</style>
